import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, NgZone, OnInit, ViewContainerRef } from '@angular/core';
import { MapApi } from '../../../api/map-api';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { AoiService } from '../../../services/aoi.service';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var defaultLatitude = -77.19428924374662;
var defaultLongitude = 40.83467074278475;
var defaultZoom = 7;
var Map;
var MapView;
var CoordinateFormatter;
var Point;
var LatLongComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LatLongComponent, _super);
    function LatLongComponent(_vcr, cdr, mapApi, layerService, aoiService, zone) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.cdr = cdr;
        _this.mapApi = mapApi;
        _this.layerService = layerService;
        _this.aoiService = aoiService;
        _this.zone = zone;
        _this.showDmsOption = false;
        _this.inputOption = 'DD';
        _this.latitudeDMS = { degrees: null, minutes: null, seconds: null };
        _this.longitudeDMS = { degrees: null, minutes: null, seconds: null };
        _this.center = [defaultLatitude, defaultLongitude];
        _this.zoom = defaultZoom;
        _this.defaultComponents = ['zoom'];
        _this.activate = function () {
            if (!_this.map) {
                _this.createMap();
            }
        };
        _this.reset = function () {
            _this._latitude = null;
            _this._longitude = null;
            if (_this.mapView) {
                _this.mapView.graphics.removeAll();
                _this.mapView.center = [defaultLatitude, defaultLongitude];
                _this.mapView.zoom = defaultZoom;
            }
        };
        _this.addResultToMap = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.aoiService.setSearchCriterias([{
                        type: 'latLong',
                        latitude: this.latitude,
                        longitude: this.longitude
                    }]);
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    Object.defineProperty(LatLongComponent.prototype, "latitude", {
        get: function () {
            return this._latitude;
        },
        set: function (val) {
            this._latitude = val;
            this.creatPoint();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LatLongComponent.prototype, "longitude", {
        get: function () {
            return this._longitude;
        },
        set: function (val) {
            this._longitude = val;
            this.creatPoint();
        },
        enumerable: true,
        configurable: true
    });
    LatLongComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.MCMap, ESRI.MCMapView, ESRI.CoordinateFormatter, ESRI.Point])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 4]), Map = _a[0], MapView = _a[1], CoordinateFormatter = _a[2], Point = _a[3];
                        this.hideMap = false;
                        this.toggleMapButton = 'Hide Map';
                        return [4 /*yield*/, CoordinateFormatter.load()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LatLongComponent.prototype.createMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.map = Map({ basemap: 'streets' });
                        return [4 /*yield*/, this.zone.runOutsideAngular(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return tslib_1.__generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = this;
                                            return [4 /*yield*/, MapView({
                                                    center: this.center,
                                                    container: this.mapAreaRef.nativeElement,
                                                    map: this.map,
                                                    ui: { components: this.defaultComponents },
                                                    zoom: this.zoom
                                                }, this.mapId, this.mapApi, this.layerService)];
                                        case 1:
                                            _a.mapView = _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        this.mapView.on('click', function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var point, dmsStr, dmsArray;
                            return tslib_1.__generator(this, function (_a) {
                                this.latitude = evt.mapPoint.latitude;
                                this.longitude = evt.mapPoint.longitude;
                                point = new Point({ latitude: this.latitude, longitude: this.longitude });
                                dmsStr = CoordinateFormatter.toLatitudeLongitude(point, 'dms', 10);
                                if (dmsStr) {
                                    dmsArray = dmsStr.split(' ');
                                    this.latitudeDMS = { degrees: parseFloat(dmsArray[0]), minutes: parseFloat(dmsArray[1]), seconds: parseFloat(dmsArray[2].substring(0, dmsArray[2].length - 1)) };
                                    this.longitudeDMS = { degrees: parseFloat(dmsArray[3]), minutes: parseFloat(dmsArray[4]), seconds: parseFloat(dmsArray[5].substring(0, dmsArray[5].length - 1)) };
                                }
                                this.cdr.detectChanges();
                                return [2 /*return*/];
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    LatLongComponent.prototype.toggleMap = function () {
        if (this.hideMap) {
            this.hideMap = false;
            this.toggleMapButton = 'Hide Map';
        }
        else {
            this.hideMap = true;
            this.toggleMapButton = 'Show Map';
        }
    };
    LatLongComponent.prototype.creatPoint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Graphic;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.latitude || !this.longitude) {
                            return [2 /*return*/];
                        }
                        this.point = {
                            type: 'point',
                            latitude: this.latitude,
                            longitude: this.longitude
                        };
                        return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _a.sent();
                        this.pointGraphic = new Graphic({
                            geometry: this.point,
                            symbol: {
                                type: 'simple-marker',
                                style: 'circle',
                                color: 'yellow',
                                size: '16px'
                            }
                        });
                        this.mapView.graphics.removeAll();
                        this.mapView.graphics.add(this.pointGraphic);
                        this.mapView.goTo(this.pointGraphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    LatLongComponent.prototype.updateLatitudeDMS = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var point;
            return tslib_1.__generator(this, function (_a) {
                if (this.latitudeDMS.degrees !== null && this.latitudeDMS.minutes !== null && this.latitudeDMS.seconds !== null) {
                    //convert DMS to DD and assign to lat
                    this.latDmsStr = this.latitudeDMS.degrees + "*" + this.latitudeDMS.minutes + "'" + this.latitudeDMS.seconds + "\"N";
                    if (this.latDmsStr && this.longDmsStr) {
                        point = CoordinateFormatter.fromLatitudeLongitude("" + this.latDmsStr + this.longDmsStr);
                        this.latitude = point.latitude;
                        this.longitude = point.longitude;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    LatLongComponent.prototype.updateLongitudeDMS = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var point;
            return tslib_1.__generator(this, function (_a) {
                if (this.longitudeDMS.degrees !== null && this.longitudeDMS.minutes !== null && this.longitudeDMS.seconds !== null) {
                    //convert DMS to DD and assign to long
                    this.longDmsStr = this.longitudeDMS.degrees + "*" + this.longitudeDMS.minutes + "'" + this.longitudeDMS.seconds + "\"W";
                    if (this.latDmsStr && this.longDmsStr) {
                        point = CoordinateFormatter.fromLatitudeLongitude("" + this.latDmsStr + this.longDmsStr);
                        this.latitude = point.latitude;
                        this.longitude = point.longitude;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], LatLongComponent.prototype, "showDmsOption", void 0);
    return LatLongComponent;
}(BaseComponent));
export { LatLongComponent };
